import { twMerge } from "tailwind-merge";
import { Skeleton } from "../../../components/Skeleton";
import { useSignedUrlQuery } from "../../../services/useSignedUrl";

/** Split a bucket-root asset key (e.g. `badge-center/onboarding/image-1.svg`) into the path + file parts useSignedUrl expects. */
function splitAssetUrl(url: string): { path?: string; key: string } {
    const slash = url.lastIndexOf("/");
    if (slash === -1) return { path: undefined, key: url };
    return { path: url.slice(0, slash), key: url.slice(slash + 1) };
}

interface OnboardingImageProps {
    /** Bucket-root S3 key of the illustration (resolved to a signed URL). */
    imageUrl?: string;
    alt?: string;
    className?: string;
}

export function OnboardingImage({ imageUrl, alt = "", className }: OnboardingImageProps) {
    const { path, key } = imageUrl ? splitAssetUrl(imageUrl) : { path: undefined, key: "" };
    const { data: url = "", isError } = useSignedUrlQuery(key, undefined, path);

    if (!imageUrl || (isError && !url)) return null;

    if (!url) return <Skeleton className={twMerge("w-full h-full rounded-[12px]", className)} />;

    return <img src={url} alt={alt} className={twMerge("object-contain", className)} />;
}
